import { useEffect, useState } from "react";

const links = [
  { id: "work", label: "Reaction Edits" },
  { id: "thumbnails", label: "Thumbnails" },
  { id: "services", label: "Services" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-[#000000]/80 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-3 md:py-4 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
          aria-label="dotMKV Media — home"
        >
          <img
            src="/img/logo.png"
            alt="dotMKV Media"
            className="h-20 md:h-24 w-auto"
          />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="font-oswald uppercase text-sm tracking-widest text-white/70 hover:text-[#00A0E4] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="nav-cta"
          href="https://cal.com/dotmkv-media-sgkgdp/30min"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:inline-flex btn-brutal text-xs"
        >
          Book a Discovery Call
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden font-oswald uppercase text-sm tracking-widest text-white"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="md:hidden bg-[#000000] border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`nav-mobile-${l.id}`}
                className="text-left font-oswald uppercase text-lg tracking-wider text-white hover:text-[#00A0E4]"
              >
                {l.label}
              </button>
            ))}
            <a
              href="https://cal.com/dotmkv-media-sgkgdp/30min"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="btn-brutal mt-2 w-fit"
              data-testid="nav-mobile-cta"
            >
              Book a Discovery Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
